const { is } = require('../../is/is')
const { isValid } = require('./isValid')

/**
 * Kiegészít egy nem valid semvert.
 * Ha valid, akkor pedig visszaadja azt.
 * @example
 * 1 -> 1.0.0
 * 1.0 -> 1.0.0
 * 1.1 -> 1.1.0
 * 1.0.0 -> 1.0.0
 * 1.2.3 -> 1.2.3
 * @param {any} semver - A megadott semver-like paraméter.
 * @returns {string | null} Vagy egy valid semver, vagy null, ha nem tudtunk vele mit kezdeni.
 */
module.exports.coerce = function coerce (semver) {
  if (isValid(semver)) {
    return semver
  }

  // Nem számmal vagy stringgel nem tudunk mit kezdeni
  if (!is.number(semver) && !is.string(semver)) {
    return null
  }

  /** @type {string} */
  const s = is.number(semver) ? `${ semver }` : semver

  if (s.startsWith('v')) {
    return coerce(s.slice(1))
  }

  if (s.indexOf(' ') > 0) {
    return coerce(s.split(' ')[0])
  }

  const clean = s
    .replace(/[^\d.]/g, ' ') // Minden, ami nem szám vagy pont, abból space legyen.
    .trim()
    .replace(/\s+/g, '.') // Csak számok és pontok maradnak.

  if (is.empty(clean)) {
    return null
  }

  const parts = clean.split('.')
  const [ major = 0, minor = 0, patch = 0 ] = parts
  const out = `${ major }.${ minor }.${ patch }`

  return out
}
